import * as React from 'react'

import { TIMEFRAME } from '../../../main/constants'
import { encodeQueryString } from '../../queryString'
import { PageType } from '../types'
import { groups } from '../utils'

interface MenuProps {
  company?: string
  activePage: PageType
  activeGroup?: string
  activeRange?: string
  showGroups?: boolean
  type?: string
  onGroupMouseEnter?: (group: string) => void
  onGroupMouseLeave?: () => void
  timeframes: {
    active: string
    link?: (timeframe: string) => string
    onClick: (timeframe: string, e: React.MouseEvent<HTMLElement>) => void
    timeframes: Array<{ key: string; title?: string; value: React.ReactNode }>
  }
  groupTimeframe?: string
  isDetailOpen?: boolean
  onTimeframeChange?: (timeframe: TIMEFRAME) => void
  onDateRangeChange?: (dateRange: string | undefined) => void
}

class Menu extends React.Component<MenuProps> {
  static defaultProps = {
    showGroups: true,
    onGroupMouseEnter: () => {},
    onGroupMouseLeave: () => {},
  }

  render() {
    var { activePage, activeGroup, showGroups, type, activeRange } = this.props
    var timeframesMenu = this.props.timeframes
    var groupTimeframe = this.props.groupTimeframe || 'd'

    return (
      <div className="menu">
        <ul className="menu-pages">
          <li className={activePage === PageType.Quotes ? 'is-active' : ''}>
            <a href="/futures.ashx">Quotes</a>
          </li>
          <li className={activePage === PageType.Performance ? 'is-active' : ''}>
            <a href="/futures_performance.ashx">Performance</a>
          </li>
          <li className={activePage === PageType.Charts ? 'is-active' : ''}>
            <a href="/futures_charts.ashx">Charts</a>
          </li>
        </ul>

        {showGroups && (
          <ul className="menu-groups">
            <li className={'all' === activeGroup ? 'is-active' : ''}>
              <a
                href={`/futures_charts.ashx?${encodeQueryString({
                  p: groupTimeframe,
                  ty: type,
                  r: activeRange,
                })}`}
              >
                All
              </a>
            </li>
            {groups.map((group) => (
              <li
                className={group.toLowerCase() === activeGroup ? 'is-active' : ''}
                onMouseEnter={this.props.onGroupMouseEnter?.bind(this, group.toUpperCase())}
                onMouseLeave={this.props.onGroupMouseLeave}
                key={group}
              >
                <a
                  href={`/futures_charts.ashx?${encodeQueryString({
                    t: group.toUpperCase(),
                    p: groupTimeframe,
                    ty: type,
                    r: activeRange,
                  })}`}
                >
                  <span className={'menu-groups_color is-' + group.toLowerCase()}></span>
                  {group}
                </a>
              </li>
            ))}
          </ul>
        )}

        <ul className="menu-timeframes">
          {timeframesMenu.timeframes.map((timeframe) => (
            <li className={timeframesMenu.active === timeframe.key ? 'is-active' : ''} key={timeframe.key}>
              <a
                href={timeframesMenu.link?.(timeframe.key)}
                onClick={timeframesMenu.onClick.bind(this, timeframe.key)}
                title={timeframe.title}
              >
                {timeframe.value}
              </a>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

export default Menu
